import React, { useState, useRef } from "react";
import Container from "react-bootstrap/Container";
import { QRCode } from "react-qrcode-logo";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import logo from "../images/mocologo.jpeg";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Alert from "react-bootstrap/Alert";

const GenerateQrCode = (props) => {
  const [qrText, setQrText] = useState("");
  const qrRef = useRef();

  const downloadQRCode = (e) => {
    e.preventDefault();
    let canvas = qrRef.current.querySelector("canvas");
    let image = canvas.toDataURL("image/png");
    let anchor = document.createElement("a");
    anchor.href = image;
    anchor.download = `MCMTA-QR-Code.png`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    setQrText("");
  };

  const qrCodeEncoder = (e) => {
    setQrText(e.target.value);
  };

  const qrCode = (
    <QRCode
      value={qrText}
      logoImage={logo}
      quietZone="50"
      size="400"
      removeQrCodeBehindLogo={true}
      qrStyle="squares"
      logoWidth={150}
      logoHeight={70}
      ecLevel="H"
      eyeRadius={[
        {
          // top/left eye
          outer: [10, 10, 0, 10],
          inner: [10, 10, 0, 10],
        },
        [10, 10, 10, 0], // top/right eye
        [10, 0, 10, 10], // bottom/left
      ]}
    />
  );

  return (
    <Container>
      <Form onSubmit={downloadQRCode}>
        <Row>
          <Col>
            <Alert variant="success">
              <Alert.Heading>Please note!</Alert.Heading>
              <p>
                This page works best on large screens. For best results use your desktop
                computer or laptop. Do not use mobile phones and/or small
                tablets. Make sure to test your newly generated QR Code before distributing it.
              </p>
              <hr />
              <p className="mb-0">
              Type the URL to generate QR Code from in the text field below. The QR code will update as you type. Once done, click the 
              "Download QR Code" button.
              </p>
            </Alert>
            <Row className="d-flex justify-content-center">
              <Form.Group className="mb-3">
                {/* <Form.Text className="text-muted">
                  Type the URL to generate QR Code from in the text field below.
                </Form.Text> */}
                <Form.Control
                  type="text"
                  placeholder="https://www.google.com"
                  name="qrText"
                  id="qrText"
                  value={qrText}
                  onChange={qrCodeEncoder}
                />
              </Form.Group>
              <Row ref={qrRef} className="d-flex justify-content-center">
              {qrCode}
              </Row>
              <Button variant="outline-primary" size="md" type="submit">
                Download QR Code
              </Button>
            </Row>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default GenerateQrCode;
